import { useQuery } from '@tanstack/react-query'

import { OrgACLAPI, OrgMembersAPI, TeamsAPI } from '@makyoapp/makyo-sdk'
import { Order } from '@makyoapp/makyo-sdk/api/api'
import { MembersOrderBy } from '@makyoapp/makyo-sdk/models/Members'
import { TeamOrderBy } from '@makyoapp/makyo-sdk/models/Teams'
import { fromSdkMemberList, fromSdkTeamList } from '@makyoapp/makyo-common'

import { queryKeys } from '@/lib/react-query'
import { useCurrentOrgContext } from '@/context/CurrentOrgContext'
import useAuth from '@/hooks/useAuth'

/**
 * Get Org Teams, this query will return teams that user and org is part of.
 */
export const useGetOrgTeams = (opts?: { search?: string }) => {
  const { userData } = useAuth()

  const { currentOrg } = useCurrentOrgContext()
  const orgID = currentOrg?.id

  const params = {
    search: opts?.search,
  }

  return useQuery({
    queryKey: [queryKeys.orgTeams, orgID, { ...params }],
    queryFn: () => {
      if (!orgID) return
      return TeamsAPI.ReqList(params.search, Order.Desc, TeamOrderBy.CreatedAt, orgID).then((res) => {
        const filtered = res?.filter((team) => team._Members.find((member) => member._UserID === userData?.id))
        return fromSdkTeamList(filtered)
      })
    },
    enabled: !!orgID && !!userData?.id,
  })
}

/**
 * Get Org member list from API
 */
export const useGetOrgMembers = (opts?: { enabled?: boolean }) => {
  const { currentOrg } = useCurrentOrgContext()
  const orgID = currentOrg?.id

  return useQuery({
    queryKey: [queryKeys.orgMembers, orgID],
    queryFn: () => {
      if (!orgID) return
      return OrgMembersAPI.ReqList(orgID, undefined, undefined, Order.Asc, MembersOrderBy.CreatedAt).then(
        fromSdkMemberList
      )
    },
    enabled: opts?.enabled ? !!orgID && opts.enabled : !!orgID,
  })
}

export const useACLQuery = () => {
  const { currentOrg } = useCurrentOrgContext()
  const orgID = currentOrg?.id

  return useQuery({
    queryKey: [queryKeys.orgACL, orgID],
    queryFn: () => {
      if (!orgID) return undefined

      return OrgACLAPI.ReqGet(orgID)
        .then((data) => {
          return data
        })
        .catch((e) => {
          if (e.status === 401) {
            console.error(e.message)
          } else {
            //printAPIError(e)
          }
        })
    },
    enabled: !!orgID,
  })
}
